{
    "ServerStatus_heading_applicationProperties": "Application Properties",
    "ServerStatus_action_refresh": "Refresh status",
    "NAME": "ServerStatusLanguage"
}
